/* eslint-disable consistent-return */
import React, { JSX } from 'react';

import { FlatList, ListRenderItemInfo, Modal } from 'react-native';

import BottomSheetHandle from 'components/BottomSheetHandle';

import styles from './styles';

type ListItem = {
    key: string;
    label: string;
    isSelected?: boolean;
};

type Props<T = ListItem> = {
    visible: boolean;
    data: T[];
    headerTitle?: string;
    renderRowItem(info: ListRenderItemInfo<T>): JSX.Element;
    keyExtractor(item: T): string;
    onClose(): void;
};

function BottomSheetAccessibleList<T = ListItem>({
    visible,
    data,
    headerTitle,
    renderRowItem,
    keyExtractor,
    onClose,
}: Props<T>) {
    return (
        <Modal
            animationType="slide"
            visible={visible}
            style={styles.modal}
            onRequestClose={onClose}
        >
            {headerTitle?.length && (
                <BottomSheetHandle title={headerTitle} onClosePress={onClose} />
            )}
            <FlatList
                style={styles.scroll}
                data={data}
                bounces={false}
                keyExtractor={keyExtractor}
                renderItem={renderRowItem}
                persistentScrollbar
                showsVerticalScrollIndicator
            />
        </Modal>
    );
}

export default BottomSheetAccessibleList;
